import React from 'react';
import { Box, Typography, Grid, Card, CardContent } from '@mui/material';
import SelfImprovementOutlinedIcon from '@mui/icons-material/SelfImprovementOutlined';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import ReplayCircleFilledOutlinedIcon from '@mui/icons-material/ReplayCircleFilledOutlined';

const feelCards = [
  {
    icon: <SelfImprovementOutlinedIcon sx={{ fontSize: 40, color: 'primary.main', mb: 1 }} />, // More Calm
    title: 'More Calm',
    desc: 'Notice more calm in your thoughts and less inner noise.'
  },
  {
    icon: <LightbulbOutlinedIcon sx={{ fontSize: 40, color: 'custom.red', mb: 1 }} />, // Clarity in Decisions
    title: 'Clarity in Decisions',
    desc: 'Feel clearer and more confident in your choices and boundaries.'
  },
  {
    icon: <FavoriteBorderOutlinedIcon sx={{ fontSize: 40, color: 'custom.blue', mb: 1 }} />, // Less Guilt & Pressure
    title: 'Less Guilt & Pressure',
    desc: 'Experience less guilt, pressure, and more self-trust.'
  },
  {
    icon: <ReplayCircleFilledOutlinedIcon sx={{ fontSize: 40, color: 'custom.yellow', mb: 1 }} />, // Coming Back to Yourself
    title: 'Coming Back to Yourself',
    desc: 'A sense of “I’m finally coming back to myself.”'
  },
];

const WhatYoullFeel = () => (
  <Box sx={{ bgcolor: 'custom.beige', py: { xs: 4, md: 6 }, px: { xs: 1, md: 0 } }}>
    <Box sx={{ maxWidth: 1100, mx: 'auto' }}>
      <Typography variant="h2" sx={{ color: 'text.main', mb: 2, textAlign: 'center', fontFamily: 'Just Another Hand' }}>
        What you’ll feel as you move through CYJ
      </Typography>
      <Typography sx={{ mb: 4, color: 'text.secondary', textAlign: 'center', fontSize: { xs: 16, md: 18 } }}>
        Women usually tell me they start noticing:
      </Typography>
      <Grid container spacing={3} justifyContent="center">
        {feelCards.map((item, idx) => (
          <Grid item xs={12} sm={6} md={3} key={item.title}>
            <Card elevation={3} sx={{ borderRadius: 3, p: 2, height: '100%', bgcolor: 'background.paper', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>{item.icon}</Box>
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>{item.title}</Typography>
                <Typography sx={{ color: 'text.secondary', fontSize: 15 }}>{item.desc}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  </Box>
);

export default WhatYoullFeel;
